import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import {
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Footer } from "../../components/Footer/Footer";

const OBJECTS_ID = {
  TATLE_01: "NTbkXt",
  TATLE_02: "EULFXL",
  TATLE_03: "zpUmh",
  TATLE_04: "xMUZX",

  INPUT_POSIT_01: "srJgppp",
  INPUT_POSIT_02: "QTrJJt",

  INPUT_TOP_1: "jmdMjJ",
  INPUT_TOP_2: "qdCtPm",
  INPUT_TOP_3: "HRShP",
  INPUT_TOP_TOGGLE: "wYsqDC",
};

function TopDesktop({ app, config }) {
  const { selections } = useSelections();
  const kpiDefaultAppliedRef = useRef(false);

  const [subTitle, setSubTitle] = useState(
    "Acompanhamento do KPI TOP Produtos no período P3M"
  );
  const [selectedValue, setSelectedValue] = useState("TOP 10 Farma");

  const [titleTable01, setTitleTable01] = useState("");
  const [titleTable02, setTitleTable02] = useState("");
  const [titleTable03, setTitleTable03] = useState("");
  const [titleTable04, setTitleTable04] = useState("");

  // Campo associado ao objeto de filtro (wYsqDC) para o toggle Pontos/% Pontos
  const [top10FieldName, setTop10FieldName] = useState("Analise_TOP");
  const [top10Options, setTop10Options] = useState([]);
  const [top10DefaultOption, setTop10DefaultOption] = useState("");
  useEffect(() => {
    const loadTop10Field = async () => {
      try {
        const fieldName = "Analise_TOP";
        setTop10FieldName(fieldName);

        const field = app.field(fieldName);
        const data = await field.getData();
        const { rows } = data || {};
        const names = (rows || []).map((row, idx) => ({
          id: `opt-${idx}`,
          name: row.qText,
          state: row.qState,
        }));

        // Normalizador robusto (remove acentos e espaços, ignora maiúsculas)
        const normalize = (v = "") =>
          v
            .toString()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, "");

        const targetPontos = normalize("Pontos TOP Produtos");
        const targetPerc1 = normalize("% Penetração");
        const targetPerc2 = normalize("%Penetração");

        // Garante ordem fixa visual, independente da ordem do Qlik:
        // 1º Pontos TOP Produtos, 2º % Penetração
        const orderedNames = [];

        const pontosRow = names.find(
          (n) => normalize(n?.name || "") === targetPontos
        );
        const percRow =
          names.find(
            (n) =>
              normalize(n?.name || "") === targetPerc1 ||
              normalize(n?.name || "") === targetPerc2
          ) || null;

        if (pontosRow) orderedNames.push(pontosRow);
        if (percRow) orderedNames.push(percRow);

        // Se existirem outras opções no futuro, adiciona depois das duas principais
        names.forEach((n) => {
          if (!orderedNames.includes(n)) {
            orderedNames.push(n);
          }
        });

        setTop10Options(orderedNames.map(({ id, name }) => ({ id, name })));

        // Sempre força "Pontos TOP Produtos" como opção padrão/selecionada,
        // usando exatamente o texto retornado pelo Qlik
        const fixedDefault = pontosRow?.name || "Pontos TOP Produtos";
        const hasFixedDefault = !!pontosRow;

        if (hasFixedDefault) {
          setTop10DefaultOption(fixedDefault);
          try {
            await field.clear();
            await field.selectMatch(fixedDefault, true);
          } catch (selectErr) {
            console.error(
              "Erro ao aplicar seleção padrão em Analise_TOP:",
              selectErr
            );
          }
        } else {
          const selected = names.find((n) => n.state === "S");
          const fallback = selected ? selected.name : names[0]?.name || "";
          setTop10DefaultOption(fallback);
        }

        console.log(
          "[TopDesktop] Opções carregadas do campo Analise_TOP:",
          names
        );
        console.log(
          "[TopDesktop] Opção padrão fixa (Pontos TOP Produtos) aplicada:",
          hasFixedDefault
        );
      } catch (err) {
        console.error("Erro ao carregar campo Analise_TOP:", err);
      }
    };
    if (app) loadTop10Field();
  }, [app]);



  const handleChange = (event) => {
    app.field("NomeTOP").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    if (!app || kpiDefaultAppliedRef.current) return;
    kpiDefaultAppliedRef.current = true;

    (async () => {
      try {
        const data = await app.field("NomeTOP").getData();
        const rows = data?.rows || [];
        const hasSelection = rows.some((r) => r.qState === "S");
        if (hasSelection) return;

        const defaultOption = rows.some(
          (r) => (r?.qText || "").trim() === "TOP 10 Farma"
        )
          ? "TOP 10 Farma"
          : (rows[0]?.qText || "TOP 10 Farma").trim();

        if (!defaultOption) return;

        await app.field("NomeTOP").selectMatch(defaultOption, true);
        setSelectedValue(defaultOption);
      } catch {}
    })();
  }, [app]);

  // Remove chamadas de variáveis para os títulos/subtítulo
  // (subTitle já inicia com valor fixo)

  // Títulos fixos das tabelas para evitar chamadas a variáveis vTexto
  useEffect(() => {
    setTitleTable01("Resumo");
    setTitleTable02("Positivação");
    setTitleTable03("PONTOS TOP Produtos");
    setTitleTable04("Batalha Naval");
  }, []);

  useEffect(() => {
    if (app) {
      const relatorios = selections.length
        ? selections.find((s) => s.qField === "NomeTOP")
        : null;
      setSelectedValue(relatorios?.qSelected || "TOP 10 Farma");
    }
  }, [app, selections]);

  return (
    <div className="app top-10">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"flex-start"}
            gap={"14px"}
          >
            {/* Título */}
            <Grid>
              <div className="container-card-title">
                <h1 className="title">TOP Produtos</h1>

                <div className="container-sutitle-form">
                  <p className="subtitle">
                    {subTitle === "" ? (
                      <CircularProgress size="30px" />
                    ) : (
                      subTitle
                    )}
                  </p>
                  <FormControl className="container-form-control">
                    <InputLabel id="select-relatorios" className="label-select">
                      KPI
                    </InputLabel>
                    <Select
                      labelId="select-relatorios"
                      className="select"
                      value={selectedValue}
                      onChange={handleChange}
                    >
                      <MenuItem value="TOP 10 Farma">TOP 10 - Farma</MenuItem>
                      <MenuItem value="TOP 10 + 5 Farma">
                        TOP 10 + 5 Farma
                      </MenuItem>
                      <MenuItem value="TOP 4 Eucerin">TOP 4 Eucerin</MenuItem>
                      <MenuItem value="TOP 10 Total Nivea">
                        TOP 10 - Total Nivea
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </Grid>

            <Grid className="container-top10">
              <Card
                app={app}
                header={{
                  hardTitle: titleTable03,
                  radio: {
                    measure: top10FieldName,
                    defaultOption: top10DefaultOption || "Pontos TOP Produtos",
                    options: top10Options.length > 0
                      ? top10Options
                      : [
                          { id: "pontos", name: "Pontos TOP Produtos" },
                          { id: "porcent", name: "% Penetração" },
                        ],
                  },
                }}
                exportContainer
                exportTable
                exportTableId={OBJECTS_ID.TATLE_03}
                expandable
                className="container-table-top-10"
              >
                <div className="container-inputs">
                  <NativeObject
                    className={"input-filter input-filter-01"}
                    app={app}
                    key={OBJECTS_ID.INPUT_TOP_1}
                    reference={{ id: OBJECTS_ID.INPUT_TOP_1 }}
                    style={{
                      height: "46px",
                    }}
                  />

                  <NativeObject
                    className={"input-filter input-filter-02"}
                    app={app}
                    key={OBJECTS_ID.INPUT_TOP_2}
                    reference={{ id: OBJECTS_ID.INPUT_TOP_2 }}
                    style={{
                      height: "46px",
                    }}
                  />

                  <NativeObject
                    className={"input-filter input-filter-03"}
                    app={app}
                    key={OBJECTS_ID.INPUT_TOP_3}
                    reference={{ id: OBJECTS_ID.INPUT_TOP_3 }}
                    style={{
                      height: "46px",
                    }}
                  />
                </div>
                <NativeObject
                  app={app}
                  key={OBJECTS_ID.TATLE_03}
                  reference={{ id: OBJECTS_ID.TATLE_03 }}
                  style={{
                    width: "100%",
                    height: "450px",
                  }}
                />
              </Card>
            </Grid>

            <Grid className="container-positivacao">
              <Card
                app={app}
                header={{
                  hardTitle: titleTable02,
                }}
                exportContainer
                exportTable
                exportTableId={OBJECTS_ID.TATLE_02}
                expandable
                className="container-table-positivacao"
              >
                <div className="container-inputs">
                  <NativeObject
                    className={"input-filter input-filter-01"}
                    app={app}
                    key={OBJECTS_ID.INPUT_POSIT_01}
                    reference={{ id: OBJECTS_ID.INPUT_POSIT_01 }}
                    style={{
                      height: "46px",
                    }}
                  />
                  <NativeObject
                    className={"input-filter input-filter-02"}
                    app={app}
                    key={OBJECTS_ID.INPUT_POSIT_02}
                    reference={{ id: OBJECTS_ID.INPUT_POSIT_02 }}
                    style={{
                      height: "46px",
                    }}
                  />
                </div>

                <NativeObject
                  app={app}
                  key={OBJECTS_ID.TATLE_02}
                  reference={{ id: OBJECTS_ID.TATLE_02 }}
                  style={{
                    width: "100%",
                    height: "450px",
                  }}
                />
              </Card>
            </Grid>


            <Grid className="container-batalha">
              <Card
                app={app}
                header={{
                  hardTitle: titleTable04,
                }}
                exportContainer
                exportTable
                exportTableId={OBJECTS_ID.TATLE_04}
                expandable
                className="container-table-evolucao"
              >
                <NativeObject
                  app={app}
                  key={OBJECTS_ID.TATLE_04}
                  reference={{ id: OBJECTS_ID.TATLE_04 }}
                  style={{
                    width: "100%",
                    height: "450px",
                  }}
                />
              </Card>
            </Grid>

            <Footer app={app} />
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

TopDesktop.defaultProps = {
  app: null,
  config: {},
};

TopDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default TopDesktop;
